import { useState } from 'react';
import { IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import StepLayout from './StepLayout';
import { modalToggleStore } from '../../../store/Store';

const ApplyPermit0 = () => {
    // 'yes' | 'no' | null. The contact instructions only show once "No" is chosen.
    const [ready, setReady] = useState(null);

    const openFirstStep = () => {
        modalToggleStore.update((s) => {
            s.permitPage = 1;
        });
    };

    return (
        <StepLayout
            title='Is your outdoor fireplace installed and are you ready to light your first fire?'
            primaryLabel='Continue'
            onPrimary={openFirstStep}
            primaryDisabled={ready !== 'yes'}
            hint={ready === 'yes' ? undefined : 'Select "Yes" to continue.'}
        >
            <p className='flow-step__lead'>
                Before proceeding, your outdoor fireplace must be installed and ready to use as an
                inspection is required prior to granting your permit.
            </p>
            <p id='fireplace-ready-question' className='flow-step__lead'>
                I confirm that my outdoor fireplace is installed and ready to use.
            </p>
            <IonRadioGroup
                value={ready}
                onIonChange={(e) => setReady(e.detail.value)}
                aria-labelledby='fireplace-ready-question'
            >
                <IonList lines='full'>
                    <IonItem>
                        <IonRadio slot='start' color='tertiary' value='yes' />
                        <IonLabel className='ion-text-wrap'>
                            <strong>Yes</strong>, my outdoor fireplace is installed and ready for
                            inspection.
                        </IonLabel>
                    </IonItem>
                    <IonItem>
                        <IonRadio slot='start' color='tertiary' value='no' />
                        <IonLabel className='ion-text-wrap'>
                            <strong>No</strong>, my outdoor fireplace is not yet ready for
                            inspection.
                        </IonLabel>
                    </IonItem>
                </IonList>
            </IonRadioGroup>
            {ready === 'no' && (
                <p role='status'>
                    Please contact the Parry Sound Fire Department{' '}
                    <a href='tel:+17057462262'>705-746-2262</a> and ask for a{' '}
                    <u>(no cost to you)</u> Outdoor Fireplace Inspection.{' '}
                    <strong>Do not purchase a fire permit until you are ready to burn.</strong>
                </p>
            )}
        </StepLayout>
    );
};

export default ApplyPermit0;
